import { ToggleButton, ToggleButtonGroup } from 'react-aria-components';
import { cx } from './parts';
import type { SegmentedProps } from './types';
import './styles';

/**
 * Сегментный переключатель для 2–4 коротких взаимоисключающих режимов
 * («Выполнено / В процессе»). Вид `.seg` из виджета предписаний. Всегда
 * выбран ровно один: снять выбор нельзя.
 */
export function Segmented<V extends string = string>({ 'aria-label': ariaLabel, value, onChange, options, size = 'sm', isFullWidth = false, className }: SegmentedProps<V>) {
  return (
    <ToggleButtonGroup
      className={cx('fm-seg', className)}
      aria-label={ariaLabel}
      data-size={size}
      data-full={isFullWidth ? '' : undefined}
      selectionMode="single"
      disallowEmptySelection
      selectedKeys={[value]}
      onSelectionChange={(keys) => {
        const next = [...keys][0];
        // Повторное нажатие на выбранном присылает тот же набор: наружу это не изменение.
        if (next !== undefined && String(next) !== value) onChange(String(next) as V);
      }}
    >
      {options.map((option) => (
        <ToggleButton key={option.id} id={option.id} isDisabled={option.isDisabled} className="fm-seg__btn">
          {option.icon ? <option.icon size={14} aria-hidden /> : null}
          {option.label}
          {option.count !== undefined ? <span className="fm-seg__count">{option.count}</span> : null}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
